import { useTranslation } from "react-i18next"

import { SectionHeading } from "../components/SectionHeading"
import {
  BODY,
  CARD,
  CONTAINER,
  DASH_ITEM,
  DASH_LIST,
  H3,
  SECTION,
  TABLE_WRAP,
  TD,
  TH,
} from "../components/styles"
import { ANCHORS, SITE } from "../site-config"

/** 条款与隐私：服务条款 / 隐私政策 / 第三方服务 / 安全保障 */
export function TermsSection() {
  const { t } = useTranslation()

  const termRow = "mb-2 flex flex-col gap-0.5 sm:flex-row sm:gap-2"
  const termLabel = "shrink-0 font-semibold text-ink sm:w-[130px]"
  const termText = "text-[15px] leading-[1.7] text-ink-secondary"

  return (
    <section id={ANCHORS.terms} className={`${SECTION} scroll-mt-[68px]`}>
      <div className={CONTAINER}>
        <SectionHeading
          eyebrow={t("official_terms_eyebrow")}
          title={t("official_terms_title")}
          lead={t("official_terms_lead", { date: SITE.effectiveDate })}
        />

        <div className="grid gap-6 lg:grid-cols-2">
          <article className={CARD}>
            <h3 className={H3}>{t("official_terms_service_title")}</h3>
            <ul className={DASH_LIST}>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l1")}</b>
                <span className={termText}>
                  {t("official_terms_service_t1")}
                </span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l2")}</b>
                <span className={termText}>
                  {t("official_terms_service_t2")}
                </span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l3")}</b>
                <span className={termText}>
                  {t("official_terms_service_t3")}
                </span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l4")}</b>
                <span className={termText}>
                  {t("official_terms_service_t4")}
                </span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l5")}</b>
                <span className={termText}>
                  {t("official_terms_service_t5")}
                </span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_service_l6")}</b>
                <span className={termText}>
                  {t("official_terms_service_t6", {
                    days: SITE.termsNoticeDays,
                  })}
                </span>
              </li>
            </ul>
          </article>

          <article id={ANCHORS.privacy} className={CARD}>
            <h3 className={H3}>{t("official_terms_privacy_title")}</h3>
            <p className={BODY}>{t("official_terms_privacy_text")}</p>

            <div className={TABLE_WRAP}>
              <table className="w-full min-w-[520px] border-collapse">
                <thead>
                  <tr>
                    <th className={TH}>{t("official_privacy_th_type")}</th>
                    <th className={TH}>{t("official_privacy_th_purpose")}</th>
                    <th className={TH}>{t("official_privacy_th_share")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-line">
                    <td className={TD}>{t("official_privacy_r1_type")}</td>
                    <td className={TD}>{t("official_privacy_r1_purpose")}</td>
                    <td className={TD}>{t("official_privacy_r1_share")}</td>
                  </tr>
                  <tr className="border-b border-line">
                    <td className={TD}>{t("official_privacy_r2_type")}</td>
                    <td className={TD}>{t("official_privacy_r2_purpose")}</td>
                    <td className={TD}>{t("official_privacy_r2_share")}</td>
                  </tr>
                  <tr className="border-b border-line">
                    <td className={TD}>{t("official_privacy_r3_type")}</td>
                    <td className={TD}>{t("official_privacy_r3_purpose")}</td>
                    <td className={TD}>{t("official_privacy_r3_share")}</td>
                  </tr>
                  <tr className="border-b border-line">
                    <td className={TD}>{t("official_privacy_r4_type")}</td>
                    <td className={TD}>{t("official_privacy_r4_purpose")}</td>
                    <td className={TD}>{t("official_privacy_r4_share")}</td>
                  </tr>
                  <tr>
                    <td className={TD}>{t("official_privacy_r5_type")}</td>
                    <td className={TD}>{t("official_privacy_r5_purpose")}</td>
                    <td className={TD}>{t("official_privacy_r5_share")}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <ul className={`mt-4 ${DASH_LIST}`}>
              <li className={DASH_ITEM}>{t("official_terms_privacy_li1")}</li>
              <li className={DASH_ITEM}>
                {t("official_terms_privacy_li2", {
                  email: SITE.privacyEmail,
                })}
              </li>
              <li className={DASH_ITEM}>{t("official_terms_privacy_li3")}</li>
            </ul>
          </article>

          <article id={ANCHORS.thirdParty} className={CARD}>
            <h3 className={H3}>{t("official_terms_third_title")}</h3>
            <p className={BODY}>{t("official_terms_third_text")}</p>
            <ul className={`mt-3 ${DASH_LIST}`}>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_third_l1")}</b>
                <span className={termText}>{t("official_terms_third_t1")}</span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_third_l2")}</b>
                <span className={termText}>{t("official_terms_third_t2")}</span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_third_l3")}</b>
                <span className={termText}>{t("official_terms_third_t3")}</span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_third_l4")}</b>
                <span className={termText}>{t("official_terms_third_t4")}</span>
              </li>
              <li className={termRow}>
                <b className={termLabel}>{t("official_terms_third_l5")}</b>
                <span className={termText}>{t("official_terms_third_t5")}</span>
              </li>
            </ul>
          </article>

          <article id={ANCHORS.safety} className={CARD}>
            <h3 className={H3}>{t("official_terms_safety_title")}</h3>
            <ul className={DASH_LIST}>
              <li className={DASH_ITEM}>{t("official_terms_safety_li1")}</li>
              <li className={DASH_ITEM}>{t("official_terms_safety_li2")}</li>
              <li className={DASH_ITEM}>{t("official_terms_safety_li3")}</li>
              <li className={DASH_ITEM}>{t("official_terms_safety_li4")}</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  )
}
